import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import { DialogActions } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import * as Icons from "react-bootstrap-icons";
import NotificationsService from "Services/http/endpoints/notifications/NotificationsService";
import fileDownload from "js-file-download";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { useTranslation } from "react-i18next";
import getFileTypeIcon from "Helpers/fileTypeIcon";

function NoticeDetails({ row }) {
  const { t } = useTranslation();
  const [showDialog, setShowDialog] = useState(false);
  const [Loading, setLoading] = useState(false);
  const { direction } = useTheme();

  const onShowDialog = () => {
    setShowDialog(true);
  };

  const onExit = async () => {
    setShowDialog(false);
  };

  const getFileDownload = async () => {
    if (row.File) {
      setLoading(true);
      const response = await NotificationsService.getNotificationsFile({
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        NoticeUserId: row.Id,
        Id: row.File.Id,
        Type: row.File.Type,
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        fileDownload(blob, row.File.FileName);
      }
      setLoading(false);
    }
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="viewDetails" />}
        icon={<Icons.CardList size={20} />}
        onClick={onShowDialog}
        className="primary-button"
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={onExit}
        TransitionProps={{ onExit: onExit }}
        fullWidth
        maxWidth="sm"
      >
        <div className="dialogHeader">
          <p>
            <span>{row.Title}</span>
          </p>
          <span
            className={`alert alert-${
              row.IsActive ? "success" : "danger"
            } p-0 px-2 m-0 mt-1 mt-sm-0`}
          >
            {row.IsActive ? t("active") : t("disable")}
          </span>
        </div>
        <DialogContent>
          <BackDropLoading loading={Loading} />
          <Grid container spacing={2}>
            <Grid item xs={12} className="d-flex flex-row align-items-center g-2">
              <span>{`${t("user")} :`}</span>
              <p className="normalTitle">{row.User}</p>
            </Grid>
            <Grid item xs={12} className="d-flex flex-row align-items-center g-2">
              <span>{`${t("post_type")} :`}</span>
              <p className="normalTitle">{row.PostType}</p>
            </Grid>
            <Grid item xs={12} className="d-flex flex-row align-items-center g-2">
              <span>{`${t("messageDate")} :`}</span>
              <p className="normalTitle">{row.DateRegister}</p>
            </Grid>
            <Grid item xs={12} className="d-flex flex-row align-items-center g-2">
              <span>{`${t("sati_ExpireJalali")} :`}</span>
              <p className="normalTitle">{row.DateExpire}</p>
            </Grid>
            <Grid item xs={12} className="d-flex flex-row align-items-center g-2">
              <span>{`${t("group_notice")} :`}</span>
              <p className="normalTitle">{row.GroupNotice}</p>
            </Grid>
            {row.Descript && (
              <Grid item xs={12} className="d-flex flex-column g-2">
                <span>{`${t("describe")} :`}</span>
                <p style={{ lineHeight: "1.7rem" }}>{row.Descript}</p>
              </Grid>
            )}
            {row.File && (
              <Grid
                item
                xs={12}
                className="d-flex flex-column g-2 border-top pt-2 mt-2"
              >
                <span>{`${t("fileAttachment")} :`}</span>
                <Grid className="file-attachment">
                  <p>{row.File.FileName}</p>
                  <MuiButton
                    className="link"
                    title={t("viewFile")}
                    innerIcon={getFileTypeIcon(row.File.FileName)}
                    disabled={row.File ? false : true}
                    onClick={getFileDownload}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={onExit} title={<Translator id="enseraf" />} />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default NoticeDetails;
